import { Avatar, Clickable, Col, Icon, Row, Text } from 'components';
import { theme } from 'lib';
import React from 'react';
import { SearchUsers } from 'screens/Admin/components';

// Channel picker for P4P admins (team admins are scoped to their own channel and never
// see this). A "channel" is a team-type User, so we search users with userType="team".
// `allChannels` is the cross-channel view: no team filter at all. It is only ever
// offered here, which keeps it P4P-only by construction — team admins never render this.
const PollTeamPicker = ({ team, onChange, label = 'Channel', allChannels, onSelectAll }) => {
  return (
    <Col noFlex wid="320px">
      {label && (
        <Text marg="0 0 4px" b2 med>
          {label}
        </Text>
      )}

      {allChannels ? (
        <Row
          center
          between
          pad="6px 10px"
          style={{
            border: `1px solid ${theme.GREY_30}`,
            borderRadius: 999,
            background: 'white',
            height: 44
          }}
        >
          <Text marg="0 0 0 6px">All channels</Text>
          <Clickable onClick={() => onChange(null)} style={{ padding: 4 }}>
            <Icon type="close" dimensions={14} />
          </Clickable>
        </Row>
      ) : team ? (
        <Row
          center
          between
          pad="6px 10px"
          style={{
            border: `1px solid ${theme.GREY_30}`,
            borderRadius: 999,
            background: 'white',
            height: 44
          }}
        >
          <Row noFlex center>
            <Avatar small user={team} avatar={team.avatar} />
            <Col marg="0 0 0 8px" noFlex>
              <Text>{team.name || team.username}</Text>
              {team.username && team.name && (
                <Text c2 col={theme.GREY_60}>
                  @{team.username}
                </Text>
              )}
            </Col>
          </Row>
          <Clickable onClick={() => onChange(null)} style={{ padding: 4 }}>
            <Icon type="close" dimensions={14} />
          </Clickable>
        </Row>
      ) : (
        <Col noFlex>
          <SearchUsers
            userType="team"
            selected={team}
            handleSelect={onChange}
            placeholder="Search channels..."
            noRounded
          />
          {onSelectAll && (
            <Clickable onClick={onSelectAll} style={{ padding: '6px 2px 0' }}>
              <Text c2 col={theme.SECONDARY}>
                Or view all channels
              </Text>
            </Clickable>
          )}
        </Col>
      )}
    </Col>
  );
};

export default PollTeamPicker;
